export default "/static/build/card-v3-2.png";